import "./EntitlementBadge.css";

/**
 * Subscription indicator.
 *
 * Everything shown here was decided by the backend and arrives on
 * `/api/me` as `entitlement`. This component chooses wording and colour and
 * nothing else — it does not compare dates, does not count days, and does not
 * infer a state from `subscription_status`. `backend/src/services/
 * entitlements.js` owns that rule; a second copy of it here would be one the
 * user could edit and one that would drift.
 *
 * Renders nothing when the backend reported no entitlement, rather than
 * guessing at a default.
 */
function EntitlementBadge({ entitlement }) {
  const label = describe(entitlement);

  if (!label) {
    return null;
  }

  return (
    <span className={`entitlement-badge is-${label.tone}`} title={label.title}>
      <span className="entitlement-badge__dot" aria-hidden="true" />
      {label.text}
    </span>
  );
}

/**
 * Maps a backend entitlement onto wording.
 *
 * @param {{state?: string, subscription_ends_at?: string|null}|null|undefined} entitlement
 * @returns {{text: string, tone: string, title: string}|null}
 */
export function describe(entitlement) {
  if (!entitlement || !entitlement.state) {
    return null;
  }

  switch (entitlement.state) {
    case "subscription_active":
      return {
        tone: "active",
        text: "Subscription active",
        title: entitlement.subscription_ends_at
          ? `Renews or ends ${new Date(entitlement.subscription_ends_at).toLocaleDateString()}`
          : "Subscription active",
      };

    case "inactive":
      return {
        tone: "expired",
        text: "No active subscription",
        title: "No active subscription",
      };

    default:
      // An unrecognised state says nothing rather than something wrong.
      return null;
  }
}

export default EntitlementBadge;
